import { motion } from "framer-motion";
import styled from "styled-components";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../../constants/design/colors";
import { FONT_CSS } from "../../../constants/design/fontSize";
import { BORDER_RADIUS, COMPONENTS, SPACING } from "../../../constants/design/spacing";
import { PaginationContainer } from "../Pagination/style";

export const TableContainerWrapper = styled(motion.div).attrs({
  transition: {
    duration: 0.25,
    ease: "easeInOut",
  },
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
})<{ $isMobile?: boolean }>`
  position: relative;
  flex: 1;

  > *:not(${PaginationContainer}) {
    margin: 0 ${({ $isMobile }) => ($isMobile ? 0 : SPACING.five)}px;
  }

  > ${PaginationContainer} {
    border-bottom-left-radius: ${BORDER_RADIUS.lg}px;
    border-bottom-right-radius: ${BORDER_RADIUS.lg}px;
    overflow: hidden;
  }
`;

export const TableHeaderWrapper = styled.div<{ $height?: string }>`
  line-height: 1;
  z-index: 2;
  display: flex;
  justify-content: space-around;
  position: sticky;
  top: 0;

  > div {
    background-color: ${BACKGROUND_COLORS.eight};
    height: ${({ $height }) => $height || `${COMPONENTS.tableHeader}px`};
    text-align: center;
    width: 100%;
    display: flex;
  }

  span {
    text-align: center;
    align-self: center;
    color: ${TEXT_COLORS.three};
    padding: ${SPACING.two}px;
  }
`;

// `onClick` is intentionally not in the generic: it is a real React handler,
// already typed by HTMLAttributes, and must keep reaching the DOM. The
// interpolation still reads it — styled-components passes every prop through —
// so the cursor still follows whether the header is clickable.
export const TableHeaderCell = styled.th`
  cursor: ${({ onClick }) => (onClick ? "pointer" : "auto")};
`;

// Used for react table library
export const TableWrapper = styled.div<{ disableHoverRow?: boolean }>`
  position: relative;
  > table {
    ${FONT_CSS.data.three}
    min-width: 100%;
    color: ${TEXT_COLORS.two};

    thead {
      top: 0;
      z-index: 2;
      height: ${COMPONENTS.tableHeader}px;
    }

    tbody {
      tr {
        transition: 0.2s all ease-in-out;
        height: ${COMPONENTS.tableRow}px;
        border-bottom: 1px solid ${BORDER_COLORS.one};
        :last-child {
          border-bottom: none;
        }

        &:hover {
          td {
            background-color: ${({ disableHoverRow }) =>
              !disableHoverRow ? LAYER_COLORS.two : undefined};
          }
        }
      }
    }

    th {
      font-weight: normal;
      color: ${TEXT_COLORS.three};
      background-color: ${LAYER_COLORS.one};
    }

    th,
    td {
      margin: 0;
      padding: 0 ${SPACING.three}px;
      text-transform: capitalize;
      white-space: nowrap;
    }
  }
`;
